// extracted by mini-css-extract-plugin
export var animationContainer = "_eh-0";
export var asteriskIcon = "_eh-8";
export var conversationLeftSection = "_eh-4";
export var conversationListItem = "_eh-3";
export var conversationMiddleSection = "_eh-5";
export var conversationRightSection = "_eh-6";
export var detailsContent = "_eh-1";
export var listContainer = "_eh-7";
export var modalContent = "_eh-2";